import { axiosAssessmentInstance } from "../AxiosConfiguration";

/**
 * Connected Health member APIs — core-lambda `/api/v4/health/*`
 * (`health_module/controller.py`), enveloped in `ResponseSchema`.
 *
 * Web is read-and-manage only: connecting Apple Health / Health Connect needs
 * the OS permission sheet on the phone, and WHOOP / Oura connect through an
 * OAuth flow that is not built yet. So the web never POSTs a connection or
 * pushes aggregates — it lists, toggles families, and disconnects.
 */

const unwrap = (res) => {
  const data = res?.data;
  if (data && typeof data === "object") return data.payload ?? data;
  return data;
};

/**
 * `GET /api/v4/health/connections` — the provider screen.
 *
 * Returns `{ connections[], providers[], copy }`, normalised so callers never
 * guard against a missing list or copy block.
 */
export const getHealthConnections = async () => {
  const res = await axiosAssessmentInstance.get("/api/v4/health/connections");
  const payload = unwrap(res) || {};
  return {
    connections: Array.isArray(payload.connections) ? payload.connections : [],
    providers: Array.isArray(payload.providers) ? payload.providers : [],
    copy: payload.copy && typeof payload.copy === "object" ? payload.copy : {},
  };
};

/**
 * `PUT /api/v4/health/permissions` — grant or revoke families for one provider
 * (`schemas.PermissionsBody`). `grants` maps a family to `GRANTED` / `DENIED`.
 * Revoking purges that family's data server-side. Returns the ConnectionView.
 */
export const updateHealthPermissions = async (provider, grants) => {
  const res = await axiosAssessmentInstance.put("/api/v4/health/permissions", {
    provider,
    grants,
  });
  return unwrap(res);
};

/**
 * `DELETE /api/v4/health/connections/{provider}` — stop sync and delete what
 * the provider contributed. Returns the (now DISCONNECTED) ConnectionView.
 */
export const disconnectHealthProvider = async (provider) => {
  const res = await axiosAssessmentInstance.delete(
    `/api/v4/health/connections/${encodeURIComponent(provider)}`
  );
  return unwrap(res);
};
